<div class="mx-auto w-full md:w-4/5">
  <yr-readonly-collection></yr-readonly-collection>
</div>
